import { TableColumns } from '@teamsnap/snap-ui';
import { ActionColumn } from 'components/common/action-column';
import { DateFormat, DateService } from 'frontend-toolkit';
import { startCase } from 'lodash';
import * as React from 'react';

const displayPaymentMethod = (item) => {
  if (item.paymentMethod) {
    if (item.paymentMethod.accountName === 'offline') {
      return `${startCase(item.paymentMethod.accountName)} ${
        item.paymentMethod.accountType
      }`;
    }

    return `${startCase(item.paymentMethod.accountName)} ending in ${
      item.paymentMethod['last_4']
    }`;
  }

  return '';
};

export const getPaymentDescription = (index: number) =>
  index === 0 ? 'Deposit, Payment 1' : `Payment ${index + 1}`; // TODO need plan info
export const getPaymentMethodType = (item: any) => displayPaymentMethod(item);

export function getColumns(
  onEdit: (_) => void,
  onCancel: (_) => void
): TableColumns {
  return {
    description: {
      label: 'Payment',
      align: 'left',
      sort: 'alpha',
      width: '13%',
    },
    amount: {
      label: 'Amount',
      headerProps: {
        tooltip: 'Does not include online fees',
      },
      align: 'left',
      sort: 'alpha',
      getBodyProps: (installment) => ({
        type: 'custom',
        children: installment.amount || '',
      }),
      width: '13%',
    },
    dueDate: {
      label: 'Due Date',
      align: 'left',
      sort: 'date',
      getBodyProps: (installment) => ({
        type: 'custom',
        children: installment.dueDate
          ? DateService.format(
              new Date(installment.dueDate),
              DateFormat.MM_DD_YYYY
            )
          : '',
      }),
      width: '13%',
    },
    paidDate: {
      label: 'Paid Date',
      align: 'left',
      sort: 'date',
      getBodyProps: (installment) => ({
        type: 'custom',
        height: 'tall',
        children: installment.paidDate
          ? DateService.format(
              new Date(installment.paidDate),
              DateFormat.MM_DD_YYYY
            )
          : '',
      }),
      width: '13%',
    },
    status: {
      label: 'Status',
      align: 'left',
      sort: 'alpha',
      getBodyProps: (installment) => ({
        type: 'custom',
        children: installment.status || '',
      }),
      width: '13%',
    },
    transactionId: {
      label: 'Transaction ID',
      align: 'left',
      sort: 'numeric',
      getBodyProps: (installment) => ({
        type: 'custom',
        children: installment.transactionId || '',
      }),
      width: '13%',
    },
    paymentMethodType: {
      label: 'Payment Method',
      align: 'left',
      sort: 'alpha',
      getBodyProps: (installment) => ({
        type: 'custom',
        children: installment.paymentMethodType || '',
      }),
      width: '13%',
    },
    actions: {
      label: '',
      align: 'center',
      width: '5%',
      getBodyProps: (installment) => ({
        type: 'custom',
        children:
          installment.status.toLowerCase() === 'scheduled' ? (
            <ActionColumn
              testId="installment-actions"
              actions={[
                {
                  label: 'Edit',
                  onClick: () => onEdit(installment),
                  icon: 'edit',
                },
                {
                  label: 'Cancel',
                  onClick: () => onCancel(installment),
                  sentiment: 'negative',
                  icon: 'delete',
                },
              ]}
            />
          ) : null,
      }),
    },
  };
}
